import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { FeedbackType, WidgetDataModel } from 'Modules'
import { Callback } from 'Types/utilTypes'

type State = {
	widgetData: WidgetDataModel
}

const initialState: State = {
	widgetData: null,
}

export namespace FeedbackWidgetNS {
	export type SetFeedbackWidget = PayloadAction<WidgetDataModel>
	export type SendWidgetFeedback = PayloadAction<{ data: FeedbackType; callback?: Callback }>
	export type UpdateWidgetFeedback = PayloadAction<{
		data: FeedbackType
		callback?: Callback
		id: number
	}>
}

export const feedbackWidgetSlice = createSlice({
	name: 'feedbackWidget',
	initialState,
	reducers: {
		setFeedbackWidget: (state, action: FeedbackWidgetNS.SetFeedbackWidget) => {
			state.widgetData = action.payload
		},
		sendWidgetFeedback: (state, action: FeedbackWidgetNS.SendWidgetFeedback) => {},
		updateWidgetFeedback: (state, action: FeedbackWidgetNS.UpdateWidgetFeedback) => {},
	},
})
